import { render, staticRenderFns } from "./WanXiang.vue?vue&type=template&id=7fb29ada&scoped=true&"
import script from "./WanXiang.vue?vue&type=script&lang=js&"
export * from "./WanXiang.vue?vue&type=script&lang=js&"
import style0 from "./WanXiang.vue?vue&type=style&index=0&id=7fb29ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb29ada",
  null
  
)

export default component.exports